import Bloc from './Bloc.js';

export default class MazePower extends Bloc {

	constructor (src, ctx) {

		super("mazepower", src, ctx);
		this.f = (src, ins) => [src.master.run.power];
		this.types = [];
	}
}
